import {sortedNumberArray} from './sortedNumberArray';

export const weekdayFormatter = (weekdays: string[], daysState: number[]) => {
  let days = sortedNumberArray(daysState);
  let retVal: string[] = [];
  days.forEach((d, i) => {
    if (i !== daysState.length - 1) {
      if (d + 1 === days[i + 1]) {
        if (retVal[retVal.length - 1] !== '-') {
          if (d + 2 === days[i + 2]) {
            retVal.push(weekdays[days[i] - 1]);
            retVal.push('-');
          } else {
            retVal.push(weekdays[days[i] - 1] + ',');
          }
        }
      } else {
        retVal.push(weekdays[days[i] - 1] + ',');
      }
    } else {
      retVal.push(weekdays[days[i] - 1]);
    }
  });
  return retVal.join(' ');
};
